import { render, staticRenderFns } from "./GalleryUpdate.vue?vue&type=template&id=1ec409cd&"
import script from "./GalleryUpdate.vue?vue&type=script&lang=js&"
export * from "./GalleryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports